import TableGenre from "../components/TableGenre"
import SideBar from "../components/SideBar"
export default function CategoriesPage(){
    return (
        <div>
            <SideBar/>
            <TableGenre/>
        </div>
    )
}